import { Button } from "@mui/material";
import { styled } from "@mui/system";

interface Props {
  rounded?: boolean;
  fontSize?: string | number;
}
export const GullButton = styled(Button)<Props>(({ rounded, fontSize }) => ({
  margin: "5px",
  fontSize: fontSize && fontSize,
  padding: "0.3rem 1rem",
  borderRadius: rounded ? "50px" : "5px",
}));
